export default "__VITE_ASSET__ClIykX7R__"